import { useState } from 'react'
import { Check, X, ChevronDown, ChevronUp } from 'lucide-react'
import type { RecentDose } from '@rondela/shared'
import { formatRelativeTime } from '../../../shared/lib/date-utils'

interface RecentDoseActivityProps {
  doses: RecentDose[]
}

export function RecentDoseActivity({ doses }: RecentDoseActivityProps) {
  // Expand by default if there are missed/skipped doses with notes
  const hasMissedWithNotes = doses.some(
    (d) => (d.status === 'missed' || d.status === 'skipped') && d.notes
  )
  const [isExpanded, setIsExpanded] = useState(hasMissedWithNotes)

  if (doses.length === 0) {
    return null
  }

  const formatTime = (isoString: string) => {
    const date = new Date(isoString)
    return date.toLocaleTimeString('es', { hour: '2-digit', minute: '2-digit' })
  }

  return (
    <div className="recent-activity">
      <button
        type="button"
        className="recent-activity-header"
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <span className="recent-activity-title">
          Actividad reciente ({doses.length})
        </span>
        {isExpanded ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
      </button>

      {isExpanded && (
        <div className="recent-activity-list">
          {doses.map((dose) => (
            <div
              key={dose.id}
              className={`recent-dose-item recent-dose-item--${dose.status}`}
            >
              <div className="recent-dose-header">
                <span className="recent-dose-icon">
                  {dose.status === 'taken' ? (
                    <Check size={14} className="icon-success" />
                  ) : (
                    <X size={14} className="icon-warning" />
                  )}
                </span>
                <span className="recent-dose-medication">
                  {dose.medicationNombre} {dose.dosis}
                </span>
                <span className="recent-dose-time">{formatTime(dose.scheduledFor)}</span>
              </div>

              <div className="recent-dose-meta">
                <span className="recent-dose-by">{dose.actionedByNombre}</span>
                <span className="recent-dose-when">{formatRelativeTime(dose.actionedAt)}</span>
              </div>

              {dose.notes && (dose.status === 'missed' || dose.status === 'skipped') && (
                <div className="recent-dose-notes">
                  <blockquote>"{dose.notes}"</blockquote>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
